import { cn } from "@pushup/ui";

interface BreadcrumbProps {
  items: Array<{ label: string; active?: boolean }>;
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav className="breadcrumb-lb" aria-label="breadcrumb">
      <ol>
        <li>YOU ARE HERE</li>
        {items.map((item) => (
          <li key={item.label} className={cn(item.active && "active")}>
            {item.label}
          </li>
        ))}
      </ol>
    </nav>
  );
}
